import React, { useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Box, Typography, Divider, Button } from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getToken, base_url } from "../../config/config";

const AttendanceMonthlyUsers = () => {
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch data from API 1
        const response1 = await fetch(`${base_url}/v1/AttendanceReportMonthly`);
        const result1 = await response1.json();
        setData1(result1);

        // Fetch data from API 2
        const response2 = await fetch(
          "http://35.159.43.224:3080/total-az-by-user-and-month",
        );
        const result2 = await response2.json();
        setData2(result2);

        // Fetch data from API 3
        const response3 = await fetch(
          "http://35.159.43.224:3080/total-az-by-user-and-month?include900=true&include9000=true",
        );
        const result3 = await response3.json();
        setData3(result3);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Define columns for each table
  const columns1 = [
    { header: "Employee", accessorKey: "employee" },
    { header: "Month", accessorKey: "month" },
    { header: "Total Hours", accessorKey: "totalHours" },
    { header: "Absence Count", accessorKey: "absenceCount" },
  ];

  const columns2 = [
    { header: "Total Az", accessorKey: "totalAz" },
    { header: "User", accessorKey: "user" },
    { header: "Year", accessorKey: "year" },
    { header: "Month", accessorKey: "month" },
  ];

  const columns3 = [
    { header: "Total Az", accessorKey: "totalAz" },
    { header: "User", accessorKey: "user" },
    { header: "Year", accessorKey: "year" },
    { header: "Month", accessorKey: "month" },
  ];

  const exportToPdf = (columns, data, title) => {
    const doc = new jsPDF();
    doc.text(title, 20, 10);
    const tableData = data.map((row) =>
      columns.map((col) => row[col.accessorKey]),
    );
    const headers = columns.map((col) => col.header);

    doc.autoTable({
      head: [headers],
      body: tableData,
      startY: 20,
    });

    doc.save(`${title}.pdf`);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant='h6'>
        Anwesenheitsbericht Monatlich nach täglicher Anwesenheit von 8 Stunden
      </Typography>
      <MaterialReactTable columns={columns1} data={data1} />
      <Button
        onClick={() =>
          exportToPdf(columns1, data1, "Anwesenheitsbericht_Monatlich")
        }>
        Export to PDF
      </Button>
      <Divider sx={{ my: 2 }} />

      <Typography variant='h6'>
        Gesamt-AZ nach Benutzer und Monat (ohne 9000)
      </Typography>
      <MaterialReactTable columns={columns2} data={data2} />
      <Button
        onClick={() => exportToPdf(columns2, data2, "Gesamt_AZ_ohne_9000")}>
        Export to PDF
      </Button>
      <Divider sx={{ my: 2 }} />

      <Typography variant='h6'>
        Gesamt-AZ nach Benutzer und Monat (nur 9000)
      </Typography>
      <MaterialReactTable columns={columns3} data={data3} />
      <Button
        onClick={() => exportToPdf(columns3, data3, "Gesamt_AZ_nur_9000")}>
        Export to PDF
      </Button>
    </Box>
  );
};

export default AttendanceMonthlyUsers;
